import { z } from 'zod';

import { BlockValueStringSchema } from './blockValueStringSchema.js';
interface BlockValueEmailSchemaArgs {
  isRequired?: boolean;
}

/**
 * @arg isRequired - if isRequired is false, the empty string is allowed. Chain the schema with .optional() if
 * the entire config property is optional.
 * @returns A Zod schema for validating values that are either block value templates or email
 */
export function BlockValueEmailSchema(args: BlockValueEmailSchemaArgs) {
  const { isRequired = false } = args;
  const blockValueOrEmailSchema = BlockValueStringSchema({
    stringValidationSchema: z.string().email({ message: 'Must be a valid email address.' }),
  });
  if (isRequired) {
    return blockValueOrEmailSchema;
  }
  return z.union([z.literal(''), blockValueOrEmailSchema]);
}
